import * as React from 'react';
import { DateRange } from 'src/utils/date';
import { GetCustomersBaseParams } from 'src/dto/CustomerNew';
import { GetAnalyticsParams } from 'src/dto/Analytics';
import { Box, styled } from '@mui/material';
import { toISOStringCET } from 'src/utils/date';
import TopIdentities from 'src/components/TopIdentities';
import FrontendAnalyticsWrapper from 'src/components/FrontendAnalytics';
import { NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';
import { useGetCustomersQuery } from 'src/redux/services/customers';
import { getFetchPayload } from 'src/components/TopIdentities/common';
export interface AnalyticsWrapperProps {
  dateRange: DateRange;
  navigateTo: NavigateCallbackFn;
}

export const Wrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  minHeight: 'calc(100vh - 280px)',
  display: 'flex',
}));

const AnalyticsDigitalScore: React.FC<AnalyticsWrapperProps> = ({ dateRange, navigateTo }) => {
  const [customersFilters, setCustomersFilters] = React.useState<GetCustomersBaseParams>({
    start: 0,
    max_items: 5,
    search: null,
    start_date: toISOStringCET(dateRange.startDate),
    end_date: toISOStringCET(dateRange.endDate),
    score_cluster: undefined,
    field: 'score_cluster',
  });

  const {
    data: customersBest,
    isFetching: isCustomersBestLoading,
    isError: isCustomersBestError,
  } = useGetCustomersQuery({
    ...customersFilters,
    sort_direction: 'desc',
    sort_field: 'score',
    ...getFetchPayload('customer'),
  });

  const {
    data: customersWorst,
    isFetching: isCustomersWorstLoading,
    isError: isCustomersWorstError,
  } = useGetCustomersQuery({
    ...customersFilters,
    sort_direction: 'asc',
    sort_field: 'score',
    ...getFetchPayload('customer'),
  });

  const [analyticsFilters, setAnalyticsFilters] = React.useState<GetAnalyticsParams>({
    start_date: toISOStringCET(dateRange.startDate),
    end_date: toISOStringCET(dateRange.endDate),
  });

  React.useEffect(() => {
    setCustomersFilters({
      ...customersFilters,
      start_date: toISOStringCET(dateRange.startDate),
      end_date: toISOStringCET(dateRange.endDate),
    });

    setAnalyticsFilters({
      start_date: toISOStringCET(dateRange.startDate),
      end_date: toISOStringCET(dateRange.endDate),
    });
  }, [dateRange]);

  return (
    <Wrapper data-testid="body">
      <FrontendAnalyticsWrapper
        product="Digital Score"
        filters={customersFilters}
        analyticsFilters={analyticsFilters}
        bestIdentities={
          <TopIdentities
            customers={customersBest?.items || []}
            isCustomersError={isCustomersBestError}
            isCustomersLoading={isCustomersBestLoading}
            pathToDetail="customer"
            tableTitle="Best Lookups"
            type="best"
            navigateTo={navigateTo}
          />
        }
        worstIdentities={
          <TopIdentities
            customers={customersWorst?.items || []}
            isCustomersError={isCustomersWorstError}
            isCustomersLoading={isCustomersWorstLoading}
            pathToDetail="customer"
            tableTitle="Worst Lookups"
            type="worst"
            navigateTo={navigateTo}
          />
        }
      />
    </Wrapper>
  );
};

export default AnalyticsDigitalScore;
